import React, { useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import '@style/counter.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { addCommas, removeNonNumeric } from '@helper';
import { Counter } from '@components';
import CollateralApplyModal from './CollateralApplyModal';
import TransFlagModal from '@components/Layout/TransFlagModal';
import HighGradeModal from './HighGradeModal';
const IsCollateral = ({ rate }) => {
    const {
        TrialBalanceStore: {
            getQryColCal,
            getColCalStock,
            collateralUIs,
            collateralStockUIs,
            setCount,
            updateData,
            getCollateralBusinessTime,
            transType,
            transInfoVisible,
            lendCollateralSwitchVisible,
            transFlagModalVisible,
            closeTransFlagModal,
            lendCollateralSwitchMessage,
            highGradeCollateralSwitch,
            TransMsg,
        },
        AuthStore: { borrowingAmount, updateUserInfo },
    } = useStore();
    useEffect(() => {
        // getQryColCal();
        getColCalStock();
    }, []);
    useEffect(() => {
        getCollateralBusinessTime();
    }, [transType]);
    const collateralArr = collateralUIs.filter(item => item.qty > 0);
    const collateralStockArr = collateralStockUIs.filter(
        item => item.stockQty > 0
    );

    return (
        <form
            onSubmit={async e => {
                e.preventDefault();
                const [, getTransFlag] = await updateUserInfo();
                if (getTransFlag === '1') {
                    updateData(
                        'TransMsg',
                        '您已完成登入，系統資料尚在更新中，請稍候再申請。'
                    );
                } else if (getTransFlag === '2') {
                    updateData('TransMsg', '作業中，請稍後再申請！');
                }
                if (getTransFlag === '1' || getTransFlag === '2') {
                    updateData('transFlagModalVisible', true);
                } else {
                    updateData('transFlagModalVisible', false);
                    updateData('declareModalVisible', true);
                }
            }}
        >
            {/* 增加擔保品鎖定 */}
            <div
                className={
                    lendCollateralSwitchVisible
                        ? 'd-none'
                        : 'message-box position-relative'
                }
            >
                <i className="icon_info list-inline-item align-middle "></i>
                <div className="d-sm-inline-block h-r3">
                    {/* 線上增加擔保品暫停服務，請洽所屬營業員或分公司協助辦理，造成不便敬請見諒。 */}
                    {lendCollateralSwitchMessage}
                </div>
            </div>
            <h4 className=" title fw-bolder mb-3">現有擔保品明細</h4>
            <p className="title mt-sm-0 mt-3 d-sm-none text-end">
                前一營業日報價資訊
            </p>
            {collateralArr.map(
                ({ stockNo, stockName, qty, closePrice, marketVal }, index) => {
                    return (
                        <ul
                            className="stock-list mb-5 d-sm-none"
                            key={`usercollateral_${index}`}
                        >
                            <li className="d-flex flex-wrap py-2 px-3 mb-3">
                                <div className="stock-choose d-flex  mb-2">
                                    <div className="stock-name text-black2 col-8">
                                        <span className="me-2">{stockNo}</span>
                                        {stockName}
                                    </div>
                                </div>
                                <div className=" d-flex align-items-baseline">
                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                        <small className="gray-light me-1">
                                            擔保品張數
                                        </small>
                                        <span className="text-black2">
                                            {qty}
                                        </span>
                                    </div>
                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                        <small className="gray-light me-1">
                                            收盤
                                        </small>
                                        <span className="pricee text-black2">
                                            <span>$</span>
                                            {closePrice}
                                        </span>
                                    </div>
                                    <div className="stock-number d-flex align-items-baseline">
                                        <small className="gray-light me-1">
                                            市價
                                        </small>
                                        <span className="pricee text-black2">
                                            <span>$</span>
                                            {addCommas(
                                                removeNonNumeric(
                                                    Math.round(
                                                        marketVal * 100
                                                    ) / 100
                                                )
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    );
                }
            )}
            <div className="desk-show table-freezes overflow-auto mt-3 mb-5">
                <table cellSpacing={0} className="table table_sty  mb-1">
                    <thead>
                        <tr>
                            <th>股票代號</th>
                            <th>股票名稱</th>
                            <th>擔保品張數</th>
                            <th className="text-end pe-5">
                                收盤價
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip>前一營業日收盤價</Tooltip>
                                    }
                                >
                                    <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                </OverlayTrigger>
                            </th>
                            <th className="text-end pe-5">
                                市值
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>前一營業日市值</Tooltip>}
                                >
                                    <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {collateralArr.map(
                            (
                                {
                                    stockNo,
                                    stockName,
                                    qty,
                                    closePrice,
                                    marketVal,
                                },
                                index
                            ) => {
                                return (
                                    <tr key={`usercollateral_${index}`}>
                                        <th>
                                            <span className="co-name">
                                                {stockNo}
                                            </span>
                                        </th>
                                        <td>{stockName}</td>
                                        <td>
                                            <div className="num_qut t-r3">
                                                {qty}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="num_price text-end pe-5">
                                                <span>$</span>
                                                {closePrice}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="num_price text-end pe-5">
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(
                                                        Math.round(
                                                            marketVal * 100
                                                        ) / 100
                                                    )
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </div>
            <h4 className=" title fw-bolder mb-3">
                可作為擔保品庫存明細
                <span className="fs-12">
                    （昨日庫存，僅顯示現股整股，不包含零股部位）
                </span>
            </h4>
            <div
                className={
                    highGradeCollateralSwitch
                        ? 'tag_quality text-center text-white ms-0 d-inline-block cur-pointer'
                        : 'd-none'
                }
                onClick={() => {
                    updateData('highGradeModalVisible', true);
                }}
            >
                優
            </div>
            <span
                className={
                    highGradeCollateralSwitch
                        ? 'text-black2 align-text-bottom fw-bolder cur-pointer'
                        : 'd-none'
                }
                onClick={() => {
                    updateData('highGradeModalVisible', true);
                }}
            >
                優質擔保品定義
            </span>
            {lendCollateralSwitchVisible && (
                <div
                    className={
                        transInfoVisible
                            ? 'd-none'
                            : 'message-box position-relative'
                    }
                >
                    <i className="icon_info list-inline-item align-middle "></i>
                    15:00 - 次營業日 9:00，
                    <div className="d-sm-inline-block">增加擔保品暫停服務</div>
                </div>
            )}

            <p className="title mt-sm-0 mt-3 d-sm-none text-end">
                前一營業日報價資訊
            </p>
            {collateralStockArr.map(
                (
                    {
                        stockNo,
                        stockName,
                        stockQty,
                        closePrice,
                        insiderFlag,
                        marketVal,
                        accommodating,
                        repayStockQty,
                        hQFlag,
                    },
                    index
                ) => {
                    return (
                        <ul
                            className="stock-list  d-sm-none"
                            key={`usercollateralStock_${index}`}
                        >
                            <li className="d-flex flex-wrap py-2 px-3 mb-3">
                                <div className="stock-choose d-flex  mb-2">
                                    <div className="stock-name text-black2 col-8">
                                        <span className="me-2">{stockNo}</span>
                                        {stockName}
                                        <small className="gray-light ms-2">
                                            張數
                                        </small>
                                        <span className="pricee text-black2">
                                            {stockQty}
                                        </span>
                                    </div>
                                    <div className="control_quty col-4">
                                        {!insiderFlag ? (
                                            !!accommodating && (
                                                // 新版Counter，增加文字輸入，待統一提出需求即可開啟
                                                <Counter
                                                    value={repayStockQty}
                                                    stockAmount={
                                                        (hQFlag === 1) &
                                                            (highGradeCollateralSwitch ===
                                                                true) ||
                                                        !highGradeCollateralSwitch
                                                            ? stockQty
                                                            : 0
                                                    }
                                                    increase={() => {
                                                        setCount({
                                                            index,
                                                            value:
                                                                repayStockQty +
                                                                1,
                                                        });
                                                    }}
                                                    decrease={() => {
                                                        setCount({
                                                            index,
                                                            value:
                                                                repayStockQty -
                                                                1,
                                                        });
                                                    }}
                                                    onChange={e => {
                                                        if (
                                                            isNaN(
                                                                e.target.value
                                                            )
                                                        ) {
                                                            e.target.value = 0;
                                                        }

                                                        if (
                                                            parseInt(
                                                                e.target.value
                                                            ) > stockQty
                                                        ) {
                                                            e.target.value =
                                                                stockQty;
                                                        }
                                                        setCount({
                                                            index,
                                                            value: +e.target
                                                                .value,
                                                        });
                                                    }}
                                                />
                                                // <Counter
                                                //     value={repayStockQty}
                                                //     stockAmount={stockQty}
                                                //     increase={() => {
                                                //         setCount({
                                                //             index,
                                                //             value:
                                                //                 repayStockQty + 1,
                                                //         });
                                                //     }}
                                                //     decrease={() => {
                                                //         setCount({
                                                //             index,
                                                //             value:
                                                //                 repayStockQty - 1,
                                                //         });
                                                //     }}
                                                //     onChange={e => {
                                                //         setCount({
                                                //             index,
                                                //             value: e.target.value,
                                                //         });
                                                //     }}
                                                // />
                                            )
                                        ) : (
                                            <b className="text-danger ps-3">
                                                內部人
                                            </b>
                                        )}
                                    </div>
                                </div>
                                <div className=" d-flex align-items-baseline">
                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                        <small className="gray-light me-1">
                                            收盤
                                        </small>
                                        <span
                                            className={`pricee text-black2 ${
                                                !accommodating || insiderFlag
                                                    ? 'opacity-50'
                                                    : ''
                                            }`}
                                        >
                                            <span>$</span>
                                            {closePrice}
                                        </span>
                                    </div>
                                    <div className="stock-number d-flex me-3 align-items-baseline">
                                        <small className="gray-light me-1">
                                            市價
                                        </small>
                                        <span
                                            className={`pricee text-black2 ${
                                                !accommodating || insiderFlag
                                                    ? 'opacity-50'
                                                    : ''
                                            }`}
                                        >
                                            <span>$</span>
                                            {addCommas(
                                                removeNonNumeric(
                                                    Math.round(
                                                        marketVal * 100
                                                    ) / 100
                                                )
                                            )}
                                        </span>
                                    </div>
                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                        <small className="gray-light me-1">
                                            融通
                                        </small>
                                        <span
                                            className={`fingbox rounded-3 text-center
                                        ${
                                            !accommodating || insiderFlag
                                                ? 'opacity-50'
                                                : ''
                                        }`}
                                        >
                                            {accommodating * 100}
                                            <span>%</span>
                                        </span>
                                        {highGradeCollateralSwitch &
                                        (hQFlag === 1) ? (
                                            <span className="tag_quality text-center text-white  ">
                                                優
                                            </span>
                                        ) : (
                                            <span></span>
                                        )}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    );
                }
            )}
            <div className="desk-show table-freezes overflow-auto mt-3">
                <table cellSpacing={0} className="table table_sty  mb-1">
                    <thead>
                        <tr>
                            <th width="13%">股票代號</th>
                            <th width="15%">股票名稱</th>
                            <th width="13%">張數</th>
                            <th width="14%">
                                <div className=" h-r">
                                    收盤價
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>前一營業日收盤價</Tooltip>
                                        }
                                    >
                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                    </OverlayTrigger>
                                </div>
                            </th>
                            <th width="16%">
                                <div className=" h-r2">
                                    市值
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>前一營業日市值</Tooltip>
                                        }
                                    >
                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                    </OverlayTrigger>
                                </div>
                            </th>
                            <th width="13%">融通成數</th>
                            <th width="16%">增加擔保品張數</th>
                        </tr>
                    </thead>
                    <tbody>
                        {collateralStockArr.map(
                            (
                                {
                                    stockNo,
                                    stockName,
                                    stockQty,
                                    closePrice,
                                    insiderFlag,
                                    marketVal,
                                    accommodating,
                                    repayStockQty,
                                    hQFlag,
                                },
                                index
                            ) => {
                                return (
                                    <tr key={`usercollateralStock_${index}`}>
                                        <th>
                                            {highGradeCollateralSwitch &
                                            (hQFlag === 1) ? (
                                                <div className="tag_quality text-center text-white  position-absolute">
                                                    優
                                                </div>
                                            ) : (
                                                <span></span>
                                            )}
                                            <span className="co-name">
                                                {stockNo}
                                            </span>
                                        </th>
                                        <td>{stockName}</td>
                                        <td>
                                            <div className="num_qut t-r3">
                                                {stockQty}
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                className={`num_price t-r ${
                                                    !accommodating ||
                                                    insiderFlag
                                                        ? 'opacity-50'
                                                        : ''
                                                }`}
                                            >
                                                <span>$</span>
                                                {closePrice}
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                className={`num_price t-r2 ${
                                                    !accommodating ||
                                                    insiderFlag
                                                        ? 'opacity-50'
                                                        : ''
                                                }`}
                                            >
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(
                                                        Math.round(
                                                            marketVal * 100
                                                        ) / 100
                                                    )
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <span
                                                className={`fingbox rounded-3 text-center ${
                                                    !accommodating ||
                                                    insiderFlag
                                                        ? 'opacity-50'
                                                        : ''
                                                }`}
                                            >
                                                {accommodating * 100}
                                                <span>%</span>
                                            </span>
                                        </td>
                                        <td>
                                            {/* {!!accommodating && !insiderFlag && (
                                                <Counter
                                                    value={repayStockQty}
                                                    stockAmount={stockQty}
                                                    increase={() => {
                                                        setCount({
                                                            index,
                                                            value:
                                                                repayStockQty +
                                                                1,
                                                        });
                                                    }}
                                                    decrease={() => {
                                                        setCount({
                                                            index,
                                                            value:
                                                                repayStockQty -
                                                                1,
                                                        });
                                                    }}
                                                    onChange={e => {
                                                        if (
                                                            isNaN(
                                                                e.target.value
                                                            )
                                                        ) {
                                                            e.target.value = 0;
                                                        }

                                                        if (
                                                            parseInt(
                                                                e.target.value
                                                            ) > stockQty
                                                        ) {
                                                            e.target.value =
                                                                stockQty;
                                                        }
                                                        setCount({
                                                            index,
                                                            value: +e.target
                                                                .value,
                                                        });
                                                    }} */}
                                            {!insiderFlag ? (
                                                !!accommodating && (
                                                    <Counter
                                                        value={repayStockQty}
                                                        stockAmount={
                                                            (hQFlag === 1) &
                                                                (highGradeCollateralSwitch ===
                                                                    true) ||
                                                            !highGradeCollateralSwitch
                                                                ? stockQty
                                                                : 0
                                                        }
                                                        increase={() => {
                                                            setCount({
                                                                index,
                                                                value:
                                                                    repayStockQty +
                                                                    1,
                                                            });
                                                        }}
                                                        decrease={() => {
                                                            setCount({
                                                                index,
                                                                value:
                                                                    repayStockQty -
                                                                    1,
                                                            });
                                                        }}
                                                        onChange={e => {
                                                            if (
                                                                isNaN(
                                                                    e.target
                                                                        .value
                                                                )
                                                            ) {
                                                                e.target.value = 0;
                                                            }

                                                            if (
                                                                parseInt(
                                                                    e.target
                                                                        .value
                                                                ) > stockQty
                                                            ) {
                                                                e.target.value =
                                                                    stockQty;
                                                            }
                                                            setCount({
                                                                index,
                                                                value: +e.target
                                                                    .value,
                                                            });
                                                        }}
                                                    />
                                                    // <Counter
                                                    //     value={repayStockQty}
                                                    //     stockAmount={stockQty}
                                                    //     increase={() => {
                                                    //         setCount({
                                                    //             index,
                                                    //             value:
                                                    //                 repayStockQty +
                                                    //                 1,
                                                    //         });
                                                    //     }}
                                                    //     decrease={() => {
                                                    //         setCount({
                                                    //             index,
                                                    //             value:
                                                    //                 repayStockQty -
                                                    //                 1,
                                                    //         });
                                                    //     }}
                                                    //     onChange={e => {
                                                    //         setCount({
                                                    //             index,
                                                    //             value: e.target
                                                    //                 .value,
                                                    //         });
                                                    //     }}
                                                    // />
                                                )
                                            ) : (
                                                <b className="text-danger ps-3">
                                                    內部人
                                                </b>
                                            )}
                                        </td>
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </div>
            <div className="totalbox text-end  py-3">
                <p className="price">
                    <label className="text-black2 align-text-bottom fw-bolder">
                        增加以上擔保品，試算維持率為
                    </label>
                    {collateralStockUIs.every(
                        stock => !parseInt(stock.repayStockQty)
                    ) ? (
                        <b className="text-danger  ps-3">尚未輸入張數</b>
                    ) : (
                        <b className="text-orange fit-3 ps-3">
                            {borrowingAmount ? Math.floor(rate * 100) / 100 : 0}
                            <span>%</span>
                        </b>
                    )}
                </p>
                <p
                    className={
                        highGradeCollateralSwitch
                            ? 'p-warn text-danger text-end fs-12'
                            : 'd-none'
                    }
                >
                    僅限增加優質擔保品
                </p>
            </div>
            <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                <button
                    className="btn_cancel m-border-0 btn rounded-pill text-end text-sm-center"
                    type="button"
                    onClick={() => {
                        updateData(
                            'collateralStockUIs',
                            collateralStockUIs.map(item => ({
                                ...item,
                                repayStockQty: 0,
                            }))
                        );
                    }}
                >
                    清 除
                </button>
                {collateralStockUIs.every(
                    stock => !parseInt(stock.repayStockQty)
                ) ? (
                    <button
                        className="btn_check btn rounded-pill text-white"
                        disabled
                    >
                        增加擔保品
                    </button>
                ) : (
                    <button
                        className="btn_check btn rounded-pill text-white"
                        type="submit"
                        disabled={
                            !transInfoVisible ||
                            // 增加擔保品鎖定
                            !lendCollateralSwitchVisible
                        }
                    >
                        增加擔保品
                    </button>
                )}
            </div>

            <CollateralApplyModal rate={rate} />
            <HighGradeModal />
        </form>
    );
};

export default observer(IsCollateral);
